

<div class="row no-gutters">
    <div class="col-6">
        <div class="row no-gutters">
            <div class="col-sm-10">
                <div class="row no-gutters">
                    <div class="col-sm-12 mt-2">
                        <mat-form-field class="full-width">
                            <mat-label>{{ user.trans.email | translate }}</mat-label>
                            <input id="{{idPrefix}}{{user.trans.email}}"
                                   type="email" matInput
                                   [formControl]="email"
                                   required>
                            <mat-error>{{ getEmailError()| translate }}</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-sm-2">

            </div>
        </div>
    </div>

    <div class="col-6">
        <div class="row no-gutters mt-4">
            <div class="col-xs-12">
                <span *ngIf="user.isVerified" class="success">
                    <mat-icon class="dr-icon">check_circle</mat-icon> {{ 'user_management.2fa.activated.' + user.authentication_method | translate }}
                </span>
                <span *ngIf="!user.authentication_method" class="warning">
                    <mat-icon class="dr-icon warning">warning</mat-icon> {{ 'user_management.2fa.not_activated' | translate }}
                </span>
                <span *ngIf="user.authentication_method && !user.isVerified" class="warning">
                    <mat-icon class="dr-icon warning">warning</mat-icon> {{ 'user_management.2fa.not_verified' | translate }}
                </span>
            </div>
        </div>
    </div>
</div>
